<template>
  <div>
    <div class="dashboard__tab">
      <b-tabs>
        <!-- All referrals -->
        <b-tab title="All Referrals" active>
          <!-- <select
            name=""
            v-model="sort"
            id=""
            class="form__select dashboard__filter"
          >
            <option :value="null" disabled selected>Filter</option>
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="paid">Paid</option>
            <option value="rejected">Rejected</option>
          </select> -->
          <!-- Search Input Field -->
          <div class="search_bar">
            <div class="dashboard__container">
              <input
                type="text"
                class="form__input dashboard__search"
                v-model="searchQuery"
                placeholder="Search"
                @keyup.enter="handleSearchReferrers"
              />
              <svgicon
                v-if="searchQuery"
                icon="cancel"
                class="cancel_icon"
                @click.prevent="clearSearchBar"
              ></svgicon>
            </div>
          </div>
          <!-- the table showing all referrers earning -->
          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
            v-if="allReferrers.length > 0 && returnedData"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Referrer
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Referral Code
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Total Earnings
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  tag="tr"
                  :to="`/referrer-details/${referrer.userId}`"
                  class="dashboard__table-row"
                  v-for="(referrer, index) in allReferrers"
                  :key="index"
                >
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    {{ pageNumber(index + 1) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ referrer.referrer }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ referrer.code }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data"
                    v-html="formatAmount(referrer.TotalEarning)"
                  ></td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: referrer.status == 'pending' },
                        { approve: referrer.status == 'active' },
                        { approve: referrer.status == 'paid' },
                        { decline: referrer.status == 'rejected' },
                        { decline: referrer.status == 'expired' },
                        { decline: referrer.status == 'unavailable' }
                      ]"
                      >{{ referrer.status | capitalize }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="`/referrer-details/${referrer.userId}`"
                      class="dashboard__payment-history-table-action"
                    >
                      View
                    </router-link>
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
          <!-- Empty referrer result -->
          <div v-if="!loader && allReferrers.length === 0 && !error">
            <empty-result />
          </div>
          <!-- error-->
          <div v-if="!loader && error">
            <error />
          </div>

          <div class="dashboard__pagination">
            <b-pagination
              v-if="allReferrers.length > 0 && returnedData"
              pills
              v-model="curPage"
              :total-rows="count"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
        </b-tab>

        <!-- the withdrawal request tab -->
        <b-tab title="Withdrawal Requests">
          <div style="display: flex; flex-direction: row-reverse; justify-content: space-between;">
            <select
              name=""
              v-model="withdrawalRequestSort"
              id=""
              class="form__select dashboard__filter"
            >
              <option :value="null" disabled selected>Filter</option>
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="processing">Processing</option>
              <option value="accepted">Accepted</option>
              <option value="paid">Paid</option>
              <option value="declined">Declined</option>
            </select>
            <!-- the search bar -->
            <div class="search_bar">
              <div class="dashboard__container">
                <input
                  type="text"
                  class="form__input dashboard__search"
                  v-model="searchQuery"
                  placeholder="Search"
                  @keyup.enter="handleSearchReferrers"
                />
                <svgicon
                  v-if="searchQuery"
                  icon="cancel"
                  class="cancel_icon"
                  @click.prevent="clearSearchBar"
                ></svgicon>
              </div>
            </div>
          </div>
          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
            v-if="withdrawalRequests.length > 0 && returnedData"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading">
                    Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Amount to Withdraw
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Approved By
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(withdrawalRequest, index) in withdrawalRequests"
                  :key="index"
                >
                  <td class="dashboard__payment-history-table-data">
                    {{ withdrawalRequest.name }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data"
                    v-html="formatAmount(withdrawalRequest.amount)"
                  ></td>
                  <td class="dashboard__payment-history-table-data">
                    {{ formatDate(withdrawalRequest.createdAt) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ withdrawalRequest.processedBy }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: withdrawalRequest.status == 'pending' },
                        {
                          pending: withdrawalRequest.status == 'processing'
                        },
                        { approve: withdrawalRequest.status == 'accepted' },
                        { approve: withdrawalRequest.status == 'paid' },
                        { decline: withdrawalRequest.status == 'declined' },
                        { decline: withdrawalRequest.status == 'expired' }
                      ]"
                      >{{ withdrawalRequest.status | capitalize }}</span
                    >
                  </td>
                  <!-- the actions -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <b-dropdown
                      id="dropdown-left"
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <svgicon
                          icon="table-menu"
                          class="dashboard__listing-table-menu"
                        ></svgicon>
                      </template>
                      <b-dropdown-item
                        @click="toggleWithdrawalRequestModal(withdrawalRequest)"
                        >View</b-dropdown-item
                      >
                      <b-dropdown-item-button
                        @click="
                          markWithdrawalRequestAsPaid(withdrawalRequest.id)
                        "
                        >Mark as paid</b-dropdown-item-button
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Empty withdrawal result -->
          <div v-if="!loader && withdrawalRequests.length === 0 && !error">
            <empty-result />
          </div>
          <!-- error-->
          <div v-if="!loader && error">
            <error />
          </div>

          <div class="dashboard__pagination">
            <b-pagination
              v-if="withdrawalRequests.length > 0 && returnedData"
              pills
              v-model="curPage"
              :total-rows="count"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <!-- the modal -->
    <AppModal
      :show="showWithdrawalRequestModal"
      @onclosed="toggleWithdrawalRequestModal"
      class="withdrawal_modal"
    >
      <p class="warning__title">Withdrawal Request</p>
      <div class="withdrawal_modal_flex">
        <p class="warning__text">
          Amount to Withdraw
        </p>
        <p
          v-if="selectedWithdrawalRequest"
          class="warning__text"
          style="font-weight: 600;"
          v-html="formatAmount(selectedWithdrawalRequest.amount)"
        ></p>
      </div>

      <!-- the approve button -->
      <button
        @click="updateWithdrawalRequest('approved')"
        class="cta_btn approve_button"
        :disabled="withdrawalLoader"
      >
        <svgicon
          v-if="withdrawalLoader"
          icon="spinner"
          class="button__loader"
        ></svgicon>
        Approve withdrawal
      </button>
      <!-- the decline button -->
      <button
        :disabled="withdrawalLoader"
        @click="updateWithdrawalRequest('declined')"
        class="cta_btn decline_withdrawal"
      >
        Decline withdrawal
      </button>
    </AppModal>

    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import {
  getReferrers,
  getWithdrawalRequests,
  markWithdrawalRequestAsPaid,
  updateWithdrawalRequest
} from "../../../services/referral";
import EmptyResult from "../general/emptyResult.vue";
import Error from "../general/error.vue";
import {
  formatCurrencyAmount,
  sumBookingPrice,
  formatReadbleDate
} from "../../utils";
export default {
  name: "ReferrersTable",
  components: {
    loader,
    EmptyResult,
    Error
  },
  data: () => {
    return {
      allReferrers: [], // the total referrers in the system
      withdrawalRequests: [], // the total withdrawal requests in the system
      loader: false,
      returnedData: true,
      sort: "all",
      withdrawalRequestSort: "processing", // for sorting withdrawal requests
      filteredBooking: [],
      searchQuery: "",
      unapprovedKYC: null,
      unapproveGuarantor: null,
      currentPage: 1,
      pageSize: 20,
      count: 0,
      page: 1,
      status: "",
      error: false,
      showWithdrawalRequestModal: false,
      selectedWithdrawalRequest: null, // to hold the selected withdrawal request
      withdrawalLoader: false
    };
  },
  methods: {
    // toggle the withdrawal request modal
    toggleWithdrawalRequestModal(request) {
      if (request) {
        this.selectedWithdrawalRequest = request; // set the selected request
      }
      this.showWithdrawalRequestModal = !this.showWithdrawalRequestModal;
    },
    clearSearchBar() {
      this.searchQuery = "";
      // this.getBookings();
    },
    handleSearchReferrers() {
      // this.$router.replace(
      //   `/booking?page=1&status=${this.status}&name=${this.searchQuery}`
      // );
      // this.getBookings();
    },
    // the function that fetches all the referrers
    getReferrers() {
      this.loader = true;
      getReferrers()
        .then(data => {
          this.loader = false;
          this.allReferrers = data.data;
          this.returnedData = true;
        })
        .catch(err => {
          this.loader = false;
          this.error = true;
          return err;
        });
    },
    // fetch all withdrawal requests
    async getWithdrawalRequests() {
      try {
        const response = await getWithdrawalRequests(
          this.getPages,
          this.pageSize,
          this.withdrawalRequestSort
        );
        this.withdrawalRequests = response.data;
      } catch (error) {
        this.error = true;
      }
    },
    // mark a withdrawal request as paid
    async markWithdrawalRequestAsPaid(id) {
      try {
        const response = await markWithdrawalRequestAsPaid(id); // mark the request as paid
        if (response.statusCode === 200) {
          this.$notification.success({
            message: "Withdrawal Request",
            description: "Withdrawal request marked as paid"
          });
        }
        this.getWithdrawalRequests(); // refresh the withdrawal requests
      } catch (error) {
        this.error = true;
        this.$notification.error({
          message: "Withdrawal Request",
          description: "Failed to mark withdrawal request as paid"
        });
      }
    },
    // approve a withdrawal request
    async updateWithdrawalRequest(status) {
      this.withdrawalLoader = true; // show loader
      try {
        const response = await updateWithdrawalRequest(
          this.selectedWithdrawalRequest.id,
          status
        ); // approve the request
        if (response.statusCode === 200) {
          this.$notification.success({
            message: "Withdrawal Request",
            description: `Withdrawal request has been ${status}`
          });
          this.showWithdrawalRequestModal = false; // close the modal
          this.selectedWithdrawalRequest = null; // reset the selected request
          this.getWithdrawalRequests(); // refresh the withdrawal requests
          this.withdrawalLoader = false; // stop loader
        }
      } catch (error) {
        this.$notification.error({
          message: "Withdrawal Request",
          description: "Error processing withdrawal request"
        });
        this.error = true;
        this.withdrawalLoader = false; // stop loader
        this.selectedWithdrawalRequest = null; // reset the selected request
      }
    },
    handlePagination(value) {
      this.currentPage = value;
      // this.$router.push(
      //   `/booking?page=${this.currentPage}&status=${this.status}&name=${this.searchQuery}`
      // );
    },
    formatAmount(data) {
      return formatCurrencyAmount(data);
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    toBase64(data) {
      return btoa(data);
    },

    pageNumber(index) {
      if (this.currentPage < 2) {
        return index;
      } else {
        return this.pageSize * (this.currentPage - 1) + index;
      }
    }
  },
  watch: {
    $route() {
      this.getReferrers();
    },
    sort(newValue) {
      this.currentPage = 1;
      if (newValue === "all") {
        this.status = "";
        // this.$router.replace(`/booking?page=1`);
        // this.getBookings();
      } else {
        this.status = newValue;
        // this.$router.replace(`/booking?page=1&status=${this.status}`);
        // this.getBookings();
      }
    },
    withdrawalRequestSort(newValue) {
      this.currentPage = 1;
      if (newValue === "all") {
        this.status = "";
        this.$router.replace(`/referral?page=1`);
        this.getWithdrawalRequests()
      } else {
        this.status = newValue;
         this.$router.replace(`/referral?page=1&status=${this.status}`);
        this.getWithdrawalRequests()
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 1;
    },
    curPage: {
      get() {
        return this.$route.query.page || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    }
  },
  async mounted() {
    const { status, page, name } = this.$route.query;
    if (page) {
      this.currentPage = Number(page);
    }
    if (status) {
      this.status = status;
    }
    if (name) {
      this.searchQuery = name;
    }
    this.getReferrers(); // fetch all referrers
    await this.getWithdrawalRequests(); // fetch all withdrawal requests
  }
};
</script>
<style scoped>
.search_bar {
  margin-bottom: 12px;
  display: flex !important;
  align-items: flex-start !important;
}
.approve_button {
  width: 100%;
}
.decline_withdrawal {
  color: red;
  margin-top: 12px;
  width: 100%;
  background-color: white;
}
.withdrawal_modal {
  padding-top: 150px;
}
.withdrawal_modal_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/referral.vue